import { lazy, Suspense } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { useRunOnce } from '@leanpay/hooks'
import { initPdfDownloadHandler } from '@leanpay/services'

import AppInit from './app-init'

import MainLayout from './main-layout'

// Lazy load devtools - only in development
const ReactQueryDevtools = lazy(() =>
    import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
    })),
)

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: true,
        },
    },
})

const App = () => {
    useRunOnce(() => {
        initPdfDownloadHandler()
    })

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AppInit>
                    <MainLayout />
                </AppInit>
            </BrowserRouter>
            {import.meta.env.DEV && (
                <Suspense fallback={null}>
                    <ReactQueryDevtools initialIsOpen={false} />
                </Suspense>
            )}
        </QueryClientProvider>
    )
}

export default App
